import getCollectionQuery from "../../utils/getCollectionQuery";

export default function getArtifactsQuery(firebase, { publisher, work, article, production, limit }) {
	return getCollectionQuery(firebase.firestore().collection("artifacts"), {
		fields: {
			publisher,
			work,
			article,
			production,
		},
		limit,
		softDeletes: true,
	});
}
